module.exports = {
    showRelatedTableFields() {
        let self = this;

        $(document).on('click', '.field_lbl', function () {
            $(this).addClass('fieldhide');
            $('.related_Fields').show();
        });

        $(document).on('change', '.showfields', function () {
            let getfield = $(this).val(),
                table_id = $('.builder-main').data('id'),
                activeField = $('body').find('.activeField').first(),
                related_fields = [];

            if (activeField) {
                if (activeField.attr('data-field') !== 'undefined' && activeField.attr('data-field') === 'relationship') {
                    if (activeField.attr('data-relfields')) {
                        related_fields = JSON.parse(activeField.attr('data-relfields'));
                    }
                }
            }

            let data = {
                getfield: getfield,
                _token: $('[name="csrf-token"]').prop('content'),
                table_id: table_id,
                related_fields
            };

            $.ajax({
                type: "GET",
                url: '/tablebuilder/getfields',
                data: data,
                success: function (data) {
                    self.populateRelationFields(data.columns, getfield);
                    self.populateFilterFields(data.filter_fields, getfield);
                    self.populateFilters(data.filters, getfield);
                }
            });

            setTimeout(function () {
                $('.field_lbl').css('display', 'block');
            }, 500);

            $('.mapping-holder').removeClass('d-none');
        });

        $(document).on('click', '.add-relation-key', (e) => {
            let related_table = $('.showfields[data-field="related-to"]').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.relation-keys').find('.row').length === 0 ? 'yes' : 'no';

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/section/primary_key',
                data: {
                    related_table: related_table,
                    curr_table: curr_table,
                    header: header,
                    type: 'primary_key'
                },
                success: (res) => {
                    $('.relation-keys-holder').find('.relation-keys').append(res);
                    this.handleRelationKeyChange();
                }
            });
        });

        $(document).on('change', '.select-primary-column', function () {
            if ($(this).val()) {
                self.markRelatedColumnAsPrimary($(this).val());
            }
        });

        $(document).on('change', '.select-filter-column', function () {
            if ($(this).val()) {
                let value = $(this).val();
                $('body').find('.activeField')
                    .attr('data-filter-column', value)
                    .data('filter-column', value);

                let $related_field = $('.cust-checkbox[value="' + value + '"]');
                if (!$related_field.is(':checked')) {
                    $related_field.trigger('click');
                }
            }
        });

        $(document).on('change', '.related-filter', function () {
            if ($(this).val()) {
                let value = $(this).val();
                $('body').find('.activeField')
                    .attr('data-related-filter', value)
                    .data('related-filter', value);
            }else{
                $('body').find('.activeField')
                    .attr('data-related-filter', '')
                    .data('related-filter', '');
            }
        });
    },

    handleAlertChanges() {
        $(document).on('change', '.alert-field', function (e) {
            e.preventDefault();
            let field = $(this).val();
            $('body').find('.activeField')
                .attr('data-alert-field', field)
                .data('alert-field', field);
        });

        $(document).on('change', 'select.alert-type', function (e) {
            e.preventDefault();
            let type = $(this).val();
            $('body').find('.activeField')
                .attr('data-alert-type', JSON.stringify(type))
                .data('alert-type', type);
        });

        $(document).on('change', 'select.alert-option', function (e) {
            e.preventDefault();
            let option = $(this).val();
            $('body').find('.activeField')
                .attr('data-alert-option', JSON.stringify(option))
                .data('alert-option', option);

            let show_options = ['minutes_before', 'hours_before', 'days_before', 'minutes_after', 'hours_after', 'days_after'],
                intersection = show_options.filter(x => option.includes(x));

            if (intersection.length) {
                $('.default-value-holder').removeClass('d-none');
            } else {
                $('.default-value-holder').addClass('d-none');
            }
        });
    },

    handleRelationKeyChange() {

        let $mappings = $('.relation-keys-holder').find('.single-primary-key'),
            keys = [];

        $mappings.each((index, $mapping) => {
            let current_table_field = $($mapping).find('.current-primary-key').val(),
                related_table_field = $($mapping).find('.related-primary-key').val();

            let key = [current_table_field, related_table_field];
            keys.push(key);
        });

        $('body')
            .find('.activeField')
            .attr('data-primary-keys', JSON.stringify(keys))
            .data('primary-keys', keys);
    },

    markRelatedColumnAsPrimary(column) {
        let columns = $('body').find('.related_Fields li input[type="checkbox"]');

        columns.each(function (e) {
            let value = $(this).val();
            if (value === column) {
                if (!$(this).is(':checked')) {
                    $(this).trigger('click');
                }

                if (!$(this).is(':disabled')) {
                    $(this).prop('disabled', true);
                }
            } else {
                if ($(this).is(':disabled')) {
                    $(this).prop('disabled', false);
                }
            }
        });

        $('body').find('.activeField')
            .attr('data-primary-column', column)
            .data('primary-column', column);

        // $('.relation-keys').empty();
        this.handleRelationKeyChange();
    },

    populateFilterFields(fields, related_id) {
        let $filter_select = $('.select-filter-column'),
            $activeField = $('.activeField'),
            filter_column = $activeField.data('filter-column');

        $filter_select.empty();
        $activeField.data('filter-column', '').attr('data-filter-column', '');

        $filter_select.append(
            `<option value="0" selected></option>`
        );

        $.each(fields, function () {
            $filter_select.append(
                `<option value="${this.id}" >${this.label}</option>`
            );
        });

        $('.filter-col-holder').removeClass('d-none');

        if (filter_column) {
            $filter_select.val(filter_column).trigger('change');
        }
    },

    populateFilters(fields, related_id) {
        let $related_field_filter = $('.related-filter'),
            $activeField = $('.activeField'),
            related_filter = $activeField.data('related-filter');

        $related_field_filter.empty();
        $activeField.data('related-filter', '').attr('data-related-filter', '');

        $related_field_filter.append(
            `<option value="" selected></option>`
        );

        $.each(fields, function () {
            $related_field_filter.append(
                `<option value="${this.id}" >${this.name}</option>`
            );
        });

        $('.filter-col-holder').removeClass('d-none');

        if (related_filter) {
            $related_field_filter.val(related_filter).trigger('change');
        }
    },


    populateRelationFields(fields, related_id) {
        let $related_fields = $('.related_Fields'),
            $primary_select = $('.select-primary-column'),
            $activeField = $('.activeField'),
            primary_column = $activeField.data('primary-column'),
            $this = this;

        $primary_select.empty();
        $related_fields.find('.list-group-item').remove();
        $activeField.data('primary-column', '').attr('data-primary-column', '');

        if ($activeField.attr('data-relid') !== related_id) {
            $activeField.attr('data-relfields', '').data('relfields', '');
        }

        $primary_select.append(
            `<option value="" selected disabled></option>`
        );

        $.each(fields, function () {
            $primary_select.append(
                `<option value="${this.id}" >${this.label}</option>`
            );

            if (this.id === primary_column) {
                $related_fields.append(
                    '<li class="list-group-item"><label class="lbl-checkbox p-0 m-0"><input class="cust-checkbox" type="checkbox" checked disabled  name="checkbox" value="' + this.id + '"/><span>' + this.label + '</span></label></li>'
                );
            } else {
                let checked = '';
                let activeField = $('body').find('.activeField').first();
                if (activeField) {
                    if (activeField.attr('data-field') !== 'undefined' && activeField.attr('data-field') === 'relationship') {
                        if (activeField.attr('data-relfields')) {
                            let relFields = JSON.parse(activeField.attr('data-relfields'));
                            if (relFields) {
                                if (relFields.includes(this.id.toString())) {
                                    checked = 'checked';
                                }
                            }
                        }
                    }
                }

                $related_fields.append(
                    '<li class="list-group-item"><label class="lbl-checkbox p-0 m-0"><input class="cust-checkbox" type="checkbox"  name="checkbox" value="' + this.id + '" ' + checked + '/><span>' + this.label + '</span></label></li>'
                );
            }

            $($related_fields).sortable({
                items: "li",
                opacity: 0.6,
                connectWith: ".connectedSortable",
                cursor: "move",
                update: (e, ui) => {
                    $this.updateRelatedFields();
                }
            }).disableSelection();
        });

        $('.primary-col-holder').removeClass('d-none');

        if (primary_column) {
            $primary_select.val(primary_column).trigger('change');
        }
    },

    updateRelatedFields() {
        let activeElm = $('body').find('.activeField');
        let selectOption = [];
        let selectField = $('body').find('.related_Fields li input[type="checkbox"]:checked');
        selectField.each(function (e) {
            selectOption.push($(this).val());
        });
        activeElm.data('relfields', selectOption).attr('data-relfields', JSON.stringify(selectOption));
    },

    fieldMapping() {

        let $body = $('body'),
            _this = this;
        $body.on('mouseenter', '.mapping-arrow', function (e) {
            $(this).removeClass('fa-long-arrow-alt-left').addClass('fa-trash-alt');
        });

        $body.on('mouseout', '.mapping-arrow', function (e) {
            $(this).removeClass('fa-trash-alt').addClass('fa-long-arrow-alt-left');
        });

        $body.on('click', '.remove-mapping > .fas', function (e) {
            $(this).parents('.single-mapping').remove();
            _this.handleMappingChange();
        });

        $body.on('click', '.add-mapping', (e) => {
            let related_table = $('.showfields').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.mapping-data').find('.row').length === 0 ? 'yes' : 'no',
                $activeField = $('.activeField');

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/mapping/fields',
                data: {
                    related_table: related_table,
                    curr_table: curr_table,
                    header: header,
                    field_id: $activeField.attr('data-id')
                },
                success: (res) => {
                    $('.mapping-holder').find('.mapping-data').append(res);
                    this.handleMappingChange();
                }
            });
        });

        $body.on('change', '.current-table-mapping, .related-table-mapping', this.handleMappingChange);
    },

    handleMappingChange(e = null) {
        if (e) {
            e.preventDefault();
        }

        let $mappings = $('.mapping-data').find('.single-mapping'),
            mappings = [];

        $mappings.each((index, $mapping) => {
            let current_table_field = $($mapping).find('.current-table-mapping').val(),
                related_table_field = $($mapping).find('.related-table-mapping').val();

            let mapping = [current_table_field, related_table_field];
            mappings.push(mapping);
        });

        $('body').find('.activeField').attr('data-mappings', JSON.stringify(mappings));
    },

    renderMappings(mappings) {
        if (mappings.length) {
            let related_table = $('.showfields').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.mapping-data').find('.row').length === 0 ? 'yes' : 'no',
                $activeField = $('.activeField');

            $('.mapping-holder').find('.mappings-loader').removeClass('d-none');

            $.ajax({
                type: 'GET',
                url: '/tablebuilder/mapping/fields',
                data: {
                    related_table: related_table,
                    curr_table: curr_table,
                    mappings: mappings,
                    header: header,
                    field_id: $activeField.attr('data-id')
                },
                success: (res) => {
                    $('.mapping-holder').find('.mapping-data').empty().append(res);
                }
            });
        }
    }
};
